import type { HttpErrorResponse } from '@angular/common/http';

import { createSingleEntityStore } from '@core/ngrx-legacy';
import { JobBoardCompanyLogo } from '@recruitee/job-boards-types';

const { actions, namespace, selectors, reducer } = createSingleEntityStore<{
  data: JobBoardCompanyLogo;
}>()('JobBoardCompanyLogo', {
  customActions: adapter => ({
    uploadCompanyLogo: (state, payload: { file: File }) => adapter.markAsPending(state),
    uploadCompanyLogoSuccess: state => adapter.markAsLoaded(state),
    uploadCompanyLogoFailed: (state, payload: HttpErrorResponse) =>
      adapter.setError(state, payload),
    deleteCompanyLogo: state => adapter.markAsPending(state),
    deleteCompanyLogoSuccess: state => adapter.markAsLoaded(state),
    deleteCompanyLogoFailed: (state, payload: HttpErrorResponse) =>
      adapter.setError(state, payload),
  }),
});

export {
  actions as JobBoardLogoUploadAction,
  namespace as JobBoardLogoUploadNamespace,
  reducer as JobBoardLogoUploadReducer,
  selectors as JobBoardLogoUploadSelector,
};
